module.exports = __webpack_public_path__ + "img/scanSuccessful.f3baea26.png";